'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var game = require('@gig/magic-sdk/dist/adapter/games/game');

const vendorsSupportingIframe = [
  game.GameVendor.PLAY_N_GO,
  game.GameVendor.YGGDRASIL,
  game.GameVendor.RED_TIGER,
  game.GameVendor.EDICT,
  game.GameVendor.PRAGMATIC_PLAY,
  game.GameVendor.EVOLUTION,
  game.GameVendor.MICROGAMING,
  game.GameVendor.IGT,
  game.GameVendor.GREEN_TUBE,
  game.GameVendor.NO_LIMIT_CITY,
  game.GameVendor.THUNDERKICK,
  game.GameVendor.SLINGO,
  game.GameVendor.GIG_GAMES,
  game.GameVendor.ORYX_GAMING,
  game.GameVendor.BLUEPRINT,
  game.GameVendor.QUICKSPIN
];
function supportsIframe(game, iframeGameProviders) {
  const providers = iframeGameProviders ? iframeGameProviders : vendorsSupportingIframe;
  return providers.includes(game.vendor);
}
function filterGamesPlatforms(games, isMobile) {
  return games.filter((game) => {
    if (!game.platform) {
      return true;
    }
    return game.platform.mobile === isMobile || game.platform.desktop === !isMobile;
  });
}
function filterDefaultCategoriesByPlatform(defaultCategories, isMobile) {
  return defaultCategories.filter((category) => isMobile ? category.toLowerCase().endsWith("-mobile") : !category.toLowerCase().endsWith("-mobile"));
}

exports.filterDefaultCategoriesByPlatform = filterDefaultCategoriesByPlatform;
exports.filterGamesPlatforms = filterGamesPlatforms;
exports.supportsIframe = supportsIframe;
